export default function InstagramPostLinks({ urls = [] }) {
  const posts = urls.filter((url) => /instagram\.com\/(reel|p|tv)\//.test(String(url)));

  if (!posts.length) {
    return null;
  }

  return (
    <section className="px-4 py-14 md:py-20" data-testid="instagram-post-links-section">
      <div className="container mx-auto max-w-5xl">
        <div className="mb-8 text-center">
          <p className="mb-2 text-xs font-medium uppercase tracking-widest text-orange-400">
            Більше робіт
          </p>
          <h2 className="text-3xl font-black text-white md:text-5xl">
            Публікації з Instagram
          </h2>
        </div>
        <div className={`grid gap-4 sm:grid-cols-2 lg:grid-cols-3 ${posts.length === 1 ? 'max-w-md mx-auto' : ''}`}>
          {posts.map((url, index) => (
            <a
              key={url}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="glass-card p-6 text-white transition-transform duration-200 hover:-translate-y-1"
              data-testid={`instagram-post-link-${index}`}
            >
              <span className="mb-3 block text-sm text-orange-400">Instagram Reel</span>
              <span className="block text-lg font-bold">Дивитися роботу #{index + 1}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}